import { render, staticRenderFns } from "./NewTeacherInstitute.vue?vue&type=template&id=0a546f25&scoped=true"
import script from "./NewTeacherInstitute.vue?vue&type=script&lang=js"
export * from "./NewTeacherInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a546f25",
  null
  
)

export default component.exports